export default "__VITE_ASSET__qd6gv1OR__"